import { render, staticRenderFns } from "./UserConnection.vue?vue&type=template&id=b6853466"
import script from "./UserConnection.vue?vue&type=script&lang=js"
export * from "./UserConnection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports